(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSActividadDetailController', SSActividadDetailController);

    SSActividadDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SSActividad', 'SSPerfil'];

    function SSActividadDetailController($scope, $rootScope, $stateParams, previousState, entity, SSActividad, SSPerfil) {
        var vm = this;

        vm.sSActividad = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:sSActividadUpdate', function(event, result) {
            vm.sSActividad = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
